// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c0512e82","239":"0f37ddc9","455":"69d12411"}[chunkId] + ".chunk.js";
};